export default {
	styleOverrides: {
		switchBase: {
			height: 'auto',
		},
	},
};
